import { Injector } from '@/config/dependency-injection'
import { Store } from 'vuex'
import { loggerFor } from '@/shared/utils/logger'

export const Loading = <T>(loader = 'global-loader', parameter?: string): MethodDecorator => {
  const log = loggerFor(`LoadingDecorator "${loader}"`)

  return (target: any, methodName: string | symbol, descriptor: PropertyDescriptor) => {
    const original: (...args: any[]) => Promise<any> = descriptor.value

    descriptor.value = function(...args: any[]): Promise<any> {
      const store = Injector.get(Store)

      let loadingKey = loader

      if (parameter != null && typeof args[0] === 'object') {
        const param = args[0][parameter]

        loadingKey += `-${param}`
      }

      store.commit('wait/START', loadingKey)

      const promise = original.apply(this, args)

      if (promise != null && 'finally' in promise) {
        promise.finally(() => {
          store.commit('wait/END', loadingKey)
        })
      } else {
        log.error(`The decorated function ${String(methodName)} does not return a Promise.`, target)
      }

      return promise
    }
  }
}
